<template>
  <div class="con-out">
    <span class="welcome">欢迎 {{ name }}</span>
    <div class="welcome logout" @click="_logOut">退出</div>
  </div>
</template>

<script>
import http from "@/util/http";
import {ElMessage, ElMessageBox} from "element-plus";

export default {
  name: "AdminTop",
  data() {
    return {
      name: undefined
    }
  },
  mounted() {
    this._userInfo()
  },
  methods: {
    _userInfo() {
      http.get('userInfo')
          .then((res) => {
            if (res.data.status === 0) {
              this.name = res.data.data.name
            }
          })
    },
    _logOut() {
      ElMessageBox.confirm(
          '是否退出？',
          '确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      )
          .then(() => {
            http.post('logOut')
                .then((res) => {
                  if (res.data.status === 0) {
                    this.name = undefined
                    ElMessage.success(res.data.content)
                    this.$router.push({
                      path: '/AdminLogin',
                    })
                  } else {
                    ElMessage.error(res.data.content)
                  }
                })
          })
          .catch(() => {

          })
    }

  }
}
</script>

<style scoped>
.con-out {
  width: 84%;
  height: 50px;
  padding: 0 8%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  background: #ffffff;
}

.welcome {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
}

.logout {
  font-size: 18px;
  color: #cd2122;
  font-weight: bold;
  margin-left: 20px;
  cursor: pointer;
}
</style>